/**
 * MedicationEditPage - Full-screen medication editing page
 * Uses new 3-box MedicationForm component
 */

import React from "react";
import { useI18nStore } from "@/stores/i18nStore";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft, Pill } from "lucide-react";
import { MedicationForm } from "@/components/medications/MedicationForm";
import { i18nToast } from "@/utils/i18nToast";

export const MedicationEditPage: React.FC = () => {
  const { t } = useI18nStore();
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  const handleClose = () => {
    navigate("/traveler/medications");
  };

  const handleSave = () => {
    i18nToast.success(t.medxUpdatedToast);
    navigate("/traveler/medications");
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center gap-4">
            <button
              onClick={handleClose}
              aria-label={t.medxBack}
              className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <ArrowLeft className="h-5 w-5 text-gray-600" />
            </button>
            <div className="flex items-center gap-3">
              <Pill className="h-6 w-6 text-blue-600" />
              <h1 className="text-2xl font-bold text-gray-900">
                {t.medxFormTitleEdit}
              </h1>
            </div>
          </div>
        </div>
      </div>

      {/* NEW 3-Box MedicationForm */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <MedicationForm
          medicationId={id}
          onClose={handleClose}
          onSave={handleSave}
        />
      </div>
    </div>
  );
};
